import React from 'react';

import type { FooterBrandMarkVariant, FooterTheme } from './footerTheme';

export type { FooterBrandMarkVariant, FooterTheme };

interface FooterBrandMarkProps {
  variant?: FooterBrandMarkVariant;
}

/** Wrangle-style oversized mesh-gradient wordmark below the marketing footer. */
const FooterBrandMark: React.FC<FooterBrandMarkProps> = ({ variant = 'home' }) => (
  <section className={`footer-brand-mark footer-brand-mark--${variant}`} aria-hidden>
    <div className="footer-brand-mark__clip">
      <p className="footer-brand-mark__text">
        <span className="footer-brand-mark__mesh">GoGrabJob</span>
      </p>
    </div>
  </section>
);

export default React.memo(FooterBrandMark);
